if (!customElements.get('wolff-cart-recommendations')) {
  customElements.define('wolff-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.addEventListener('change', event => {
        const select = event.target.closest('select[name="id"]');
        if (!select) return;
        select.closest('[data-recommendation-product]').querySelector('[data-recommendation-price]').textContent = select.selectedOptions[0].dataset.price;
      }, {signal: this.events.signal});
      this.addEventListener('submit', event => {
        const form = event.target.closest('[data-recommendation-form]');
        if (!form) return;
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || !window.routes?.cart_add_url) return; // Native form fallback.
        event.preventDefault();
        if (window.wolffCartRecommendationPending || window.wolffCartMutationPending) return;
        this.add(form, drawer);
      }, {signal: this.events.signal});
    }
    async add(form, drawer) {
      window.wolffCartRecommendationPending = true;
      const controls = [...this.querySelectorAll('button,select')];
      const payload = new FormData(form); // Read before disabling variant selectors.
      controls.forEach(control => { control.disabled = true; });
      form.setAttribute('aria-busy', 'true');
      const error = this.querySelector('[role="alert"]');
      error.hidden = true;
      drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
      const sections = drawer.getSectionsToRender();
      payload.append('sections', sections.map(section => section.id).join(','));
      payload.append('sections_url', window.location.pathname);
      let added = false;
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST', headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: payload
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
        added = true;
        if (sections.some(section => !data.sections?.[section.id])) throw new Error(this.dataset.refreshError);
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        const status = document.getElementById('CartDrawer-LiveRegionText');
        if (status) status.textContent = this.dataset.added;
      } catch (failure) {
        error.textContent = added ? this.dataset.refreshError : (failure.message || this.dataset.error);
        error.hidden = false;
        if (added) {
          // The cart write succeeded. Never let a refresh failure cause a duplicate add.
          form.querySelector('[type="submit"]').dataset.added = 'true';
          const link = document.createElement('a');
          link.href = window.routes.cart_url;
          link.textContent = this.dataset.added;
          error.append(' ', link);
        }
      } finally {
        controls.forEach(control => { control.disabled = control.dataset.added === 'true'; });
        form.removeAttribute('aria-busy');
        window.wolffCartRecommendationPending = false;
      }
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
